module.exports = __webpack_public_path__ + "img/user-1.660ba856.png";